<template>
  <div class="imgUpload" :class="{ 'is-button': mode === 'button' }">
    <el-upload
      ref="upload"
      action="image/*"
      v-bind="$attrs"
      v-on="$listeners"
      :multiple="multiple"
      :show-file-list="showFileList"
      :auto-upload="autoUpload"
      class="avatar-uploader"
      :on-change="onChange"
      :accept="accept"
    >
      <template v-if="mode === 'button'">
        <el-button type="primary" size="small">{{ buttonText }}</el-button>
      </template>
      <template v-else>
        <el-image class="avatar" fit="contain" :style="{ 'max-width': width }" :src="value" v-if="value" />
        <i class="el-icon-plus avatar-uploader-icon" v-else></i>
      </template>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: {
    open: {
      default: false
    },
    multiple: {
      default: false
    },
    showFileList: {
      default: false
    },
    autoUpload: {
      default: false
    },
    accept: {
      default: '.jpg,.jpeg,.png'
    },
    buttonText: {
      default: '上传'
    },
    /** button：按钮样式；avatar：预览框样式 */
    mode: {
      type: String,
      default: 'avatar'
    },
    /** 字节上限，如 500*1024 */
    size: {
      default: ''
    },
    width: {
      default: '400px'
    },
    value: {
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      url: '',
    }
  },
  watch: {
    open: {
      handler: function () {
        this.url = ''
        this.$refs.upload.clearFiles();
      },
      deep: true,
      immediate: false,
    }
  },
  methods: {
    async onChange(file) {
      if (!file || !file.raw) return
      if (this.size && file.raw.size > this.size) {
        this.$message.error(
          this.$utils && this.$utils.bytesToSize
            ? '上传图片大小不能超过' + this.$utils.bytesToSize(this.size)
            : '上传图片大小超出限制'
        )
        this.$refs.upload.clearFiles()
        return
      }
      this.loading = true;
      this.$emit('loading', this.loading)
      try {
        const res = await this.$http.post(`/student/pc/common/uploadImage`, { base64Image: await this.getBase64(file.raw) });
        this.url = res
        this.$emit('input', res)
        this.$emit('success', { url: res, name: file.name })
      } finally {
        this.loading = false;
        this.$emit('loading', this.loading)
      }
    },
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
  }
}
</script>
<style lang="scss">
.imgUpload{
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

&.is-button {
  .avatar-uploader .el-upload {
    border: none;
    border-radius: 0;
    overflow: visible;
  }
}
}
</style>
